/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { TaskInstance } from 'ember-concurrency';

interface CioSendTestContentCancelButtonArgs {
  sendTest: TaskInstance<unknown>;
  onClose?: () => unknown;
}

export default class CioSendTestContentCancelButton extends Component<CioSendTestContentCancelButtonArgs> {
  @action
  onClose() {
    this.args.onClose?.();
  }
}
